import { render } from "./DataWali.vue?vue&type=template&id=46970635"
import script from "./DataWali.vue?vue&type=script&lang=js"
export * from "./DataWali.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__